import config from '../config/index';
import { request } from './api';
export default {
  getActivityDetail ({ activityId }) {
    return request({
      type: 'get',
      dataType: 'json',
      url: config.dealerCloudVrapi + '/vrapi/dealer/activityDetail',
      data: { activityId },
      transformResponse: function (data) {
        if (data.returncode === 0) {
          return data;
        }
        else {
          return data;
        }
      }
    });
  }
};
